import * as THREE from 'three';
import * as CANNON from 'cannon-es';
import PhysVisUtil from "@/PhysVisUtil";
import CameraEngineChaseCopter from './CameraEngineChaseCopter';
import CameraEngineOrbital from './CameraEngineOrbital';
import alea from 'alea';
import {createNoise2D} from 'simplex-noise';
import { Water } from 'three/examples/jsm/objects/Water';
import Car from './Car';
import Stats from 'three/examples/jsm/libs/stats.module'

class GameSceneRace {

	sceneRootObject: THREE.Object3D = null!;
	
	directionalLight: THREE.DirectionalLight = null!;

	levelFloor: THREE.Object3D;

	car: Car = null!;

	physVisUtil: PhysVisUtil;

	world: CANNON.World;
	
	canvas: any;
	
	groundMaterial: any;
	


	cameraEngineChaseCopter: any = null!;
	cameraEngineOrbital: any = null!;
	
	camera: THREE.PerspectiveCamera = null!;  // камера из CameraEngine

	renderer: THREE.WebGLRenderer;
	scene: THREE.Scene;

//	cameraMode = "chaseCopter";
	cameraMode = "orbital";

	//heightfieldSize = 0;
	//elementSize = 0;
	
	stats: Stats;

	noise2D;

///	TERRAIN_PHYS_SQUARE_SIZE = 20; // размер физического квадрата, м
	TERRAIN_PHYS_SQUARE_SIZE = 24; // размер физического квадрата, м
//	TERRAIN_PHYS_RESOLUTION = 20; // сколько метров между вершинами - физика
//	TERRAIN_PHYS_RESOLUTION = 10; // сколько метров между вершинами - физика
	TERRAIN_PHYS_RESOLUTION = 24; // сколько метров между вершинами - физика
//	TERRAIN_PHYS_RESOLUTION = 12; // сколько метров между вершинами - физика
//	TERRAIN_PHYS_RESOLUTION = 4; // сколько метров между вершинами - физика
//	TERRAIN_PHYS_RESOLUTION = 1; // сколько метров между вершинами - физика
	
//	TERRAIN_GRAPH_SQUARE_SIZE = 120; // размер графического квадрата, м
///	TERRAIN_GRAPH_SQUARE_SIZE = 140; // размер графического квадрата, м
	TERRAIN_GRAPH_SQUARE_SIZE = 168; // размер графического квадрата, м
	
//	TERRAIN_GRAPH_RESOLUTION_0 = 4; // сколько метров между вершинами - графика
//	TERRAIN_GRAPH_RESOLUTION_1 = 6; // сколько метров между вершинами - графика
//	TERRAIN_GRAPH_RESOLUTION_2 = 12; // сколько метров между вершинами - графика

//	TERRAIN_GRAPH_RESOLUTION_0 = 15; // сколько метров между вершинами - графика
//	TERRAIN_GRAPH_RESOLUTION_1 = 15; // сколько метров между вершинами - графика
//	TERRAIN_GRAPH_RESOLUTION_2 = 15; // сколько метров между вершинами - графика

///	TERRAIN_GRAPH_RESOLUTION_0 = 20; // сколько метров между вершинами - графика
///	TERRAIN_GRAPH_RESOLUTION_1 = 20; // сколько метров между вершинами - графика
///	TERRAIN_GRAPH_RESOLUTION_2 = 20; // сколько метров между вершинами - графика
	TERRAIN_GRAPH_RESOLUTION_0 = 24; // сколько метров между вершинами - графика
	TERRAIN_GRAPH_RESOLUTION_1 = 24; // сколько метров между вершинами - графика
	TERRAIN_GRAPH_RESOLUTION_2 = 24; // сколько метров между вершинами - графика

//	TERRAIN_NUM_GRAPH_LAYERS = 9;
	TERRAIN_NUM_GRAPH_LAYERS = 7;
//	TERRAIN_NUM_GRAPH_LAYERS = 5;

    physSquares = new Map<string, CANNON.Body>();  // физические квадраты
    physSquaresVisual = new Map<string, THREE.Object3D>();  // физические квадраты, отладочное отображение

    physStrings = new Map<string, CANNON.Body>();  // физические строки дорожной насыпи
    physStringsVisual = new Map<string, THREE.Object3D>();  // физические квадраты, отладочное отображение

     
    graphSquares = new Map<string, THREE.Object3D>();  // графические квадраты

	physSquaresList: string[] = [];
	graphSquaresList: string[] = [];

	physStringsList: string[] = [];
	
	materialGround: any = null!;
	materialMountains: any = null!;
	materialRoad: any = null;
	
	water: any = null!;

	MAX_HEIGHT_MOUNTAINS = 300;
	MAX_HEIGHT_GROUND = 10;

	ROAD_HALF_WIDTH = 6;
	ROAD_HALF_WIDTH_GROUND = 15;	// отодвигаем холмы от дороги
	ROAD_HALF_WIDTH_MOUNTAINS = 20;	// отодвигаем горы от дороги
	
	ROAD_SLOPE_WIDTH_GROUND = 120 * 2; // ширина откоса земли вдоль дороги, м
	ROAD_SLOPE_WIDTH_MOUNTAINS = 120 * 2 * 4; // ширина откоса гор вдоль дороги, м

	ROAD_AMPLITUDE_X = 150;  // изгибы дороги влево-вправо	
	ROAD_AMPLITUDE_Y = 200;	 // изгибы дороги вверх-вниз
	
	ROAD_BANK_HEIGHT = 0.3; // высота насыпи дороги, м
	ROAD_BANK_WIDTH = 1.5; // ширина откоса насыпи дороги, м

	terrainPhysicsShow = false;
	
	visibleObjectPhysSquares: THREE.Object3D;
	visibleObjectPhysStrings: THREE.Object3D;
	
//	carMode = 0; // физика на основе first car shooter (едем по trimesh)
//	carMode = 1; // raycastvehicle (едем по heightmap)
	carMode = 2; // rigidvehicle (едем по trimesh)

	///////////////////////////////////////////////////////////////////////////////////
	constructor(scene: THREE.Scene, canvas: any, renderer: THREE.WebGLRenderer) {
		
		console.log("GameLevel.constructor");
		
		this.visibleObjectPhysSquares = new THREE.Object3D();
		this.visibleObjectPhysStrings = new THREE.Object3D();

		this.renderer = renderer;
		this.scene = scene;
		
		this.canvas = canvas;
		
		this.physVisUtil = new PhysVisUtil();

		this.levelFloor = null!;

		this.groundMaterial = new CANNON.Material('ground');

		// присоединяем уровень к сцене, генерируем его
		this.world = new CANNON.World();
//        this.world.gravity.set(0, -9.8, 0)
        this.world.gravity.set(0, -1, 0)
//        this.world.gravity.set(0, -1, 0.5)

		
		if (this.carMode == 1) { // raycast-, rigidvehicle
			this.world.broadphase = new CANNON.SAPBroadphase(this.world);
			this.world.defaultContactMaterial.friction = 0;
		} else if (this.carMode == 2) {
			this.world.broadphase = new CANNON.SAPBroadphase(this.world);
//			this.world.defaultContactMaterial.friction = 0.2;
			this.world.defaultContactMaterial.friction = 10;  // чтобы перевернувшаяся машина быстро закапывалась в грунт, а не скользила непонятно куда
		}

		this.sceneRootObject = new THREE.Object3D();
		scene.add(this.sceneRootObject);


		const prng = alea('bebebe');
		console.log("prng = " + prng);
		
		this.noise2D = createNoise2D(prng);
		
		console.log("noises created");




		this.createWater();

		const initY = 30;
///		const initY = 50;
		const initZ = 450;
		
		// ставим машину точно на дорогу (потом и по Y так сделать)
		const pz = (initZ / 4 + 128) * 2 / 256;
		const initX = this.ROAD_AMPLITUDE_X * this.noise2D(pz / 4, 0);  // метры

		this.car = new Car(this.carMode, this.sceneRootObject, this.world, this.groundMaterial, 
							initX, initY, initZ, this.ROAD_AMPLITUDE_X, this.noise2D);

        this.world.addEventListener('postStep', () => {

			///this.car.animate();
			
            // Gravity towards (0,0,0)
            this.world.bodies.forEach((b) => {
                const v = new CANNON.Vec3()
                //v.set(-b.position.x, -b.position.y, -b.position.z).normalize()  // сферическая гравитация, для заездов на астероиде
                v.set(0, -1, 0)
                v.scale(9.8, b.force)
//                v.scale(9.8 * 0, b.force)  // для отладки уменьшаю гравитацию
                b.applyLocalForce(v)
////                b.force.y += b.mass //cancel out world gravity
// ^- отсюда и получалось опрокидывание
            })
        })



		//this.createVehicle(this.sceneRootObject);

		const position = this.car.getPhysBodyPosition();
		const quaternion = this.car.getPhysBodyQuaternion();
		this.cameraEngineChaseCopter = new CameraEngineChaseCopter(scene, position, quaternion);

console.log("*");		
		this.cameraEngineOrbital = new CameraEngineOrbital(scene, this.canvas.value);  // т.к. value - это HTML canvas, принимающий события, а this.canvas - webGl-обвязка  
console.log("**");		
		
//		this.cameraMode = "chaseCopter";
		this.cameraMode = "orbital";
		this.changeCameraMode();	// по умолчанию пусть будет вид с тыла машины

		
		this.addLights(scene);

		this.addControls();
		
		// skybox
		const loader = new THREE.CubeTextureLoader();
		loader.setPath('images/skyboxes/interstellar/');

		const textureCube = loader.load([
			'xpos.png', 'xneg.png',
			'ypos.png', 'yneg.png',
			'zpos.png', 'zneg.png'
		]);

		scene.background = textureCube;
		
		
		
//		const color = "#D0FFE0";  // туман - дальние горы делаем рериховского цвета
		const color = "#B0E0C0";  // лучше пусть зеленоватый, из-за выбранного скайбокса
//		scene.fog = new THREE.Fog(color, 750, 1500);
		scene.fog = new THREE.Fog(color, 400, 1000);
//		scene.fog = new THREE.Fog(color, 300, 700);
		
		this.stats = new Stats();
		document.body.appendChild(this.stats.dom);
		
		// материалы
		const textureLoader = new THREE.TextureLoader();
		
		//let texture = textureLoader.load('/images/terrain_plain.png');
//		let texture = textureLoader.load('/images/grass-stone-mountain_base_1k.jpg');

//		let texture = textureLoader.load('/images/rocks-land_base_1k.jpg');
//		const textureNormal = textureLoader.load('/images/rocks-land_normal_1k.jpg');

//		let texture = textureLoader.load('/images/grass-stone-mountain_base_1k.jpg');
//		let textureNormal = textureLoader.load('/images/grass-stone-mountain_normal_1k.jpg');

		let texture = textureLoader.load('images/grass-gravel_base_1k.jpg');
		let textureNormal = textureLoader.load('images/grass-gravel_normal_1k.jpg');
		
		///const textureDisp = textureLoader.load('/images/rocks-land_disp_1k.jpg');
//		this.materialGround = new THREE.MeshLambertMaterial({ map: texture });
		this.materialGround = new THREE.MeshStandardMaterial({ map: texture, normalMap: textureNormal/*, displacementMap: textureDisp*/ });
//		this.materialGround = new THREE.MeshPhongMaterial({ map: texture });

//		texture = textureLoader.load('/images/dirty-rock-2048x2048.jpg');

//		texture = textureLoader.load('/images/rocks-land_base_1k.jpg');
//		textureNormal = textureLoader.load('/images/rocks-land_normal_1k.jpg');
		texture = textureLoader.load('images/rocks-land_base_1k.jpg');
		textureNormal = textureLoader.load('images/rocks-land_normal_1k.jpg');
		
		this.materialMountains = new THREE.MeshLambertMaterial({ map: texture, normalMap: textureNormal });
//this.materialMountains = new THREE.MeshBasicMaterial({ color: 0x80ff80, wireframe: true });
		
		
		//const texture = loader.load('/images/Seamless-Road-Texture1.jpg');
		//texture = textureLoader.load('/images/RoadsDirt0082_2_500.jpg');
		texture = textureLoader.load('images/RoadsDirt0070_1_350.jpg');
		//texture = textureLoader.load('/images/RoadsDirt0070_1_350_square.jpg');
		this.materialRoad = new THREE.MeshLambertMaterial({ map: texture });
		
		
		
//		const el = document.getElementById("canvas");
//		if (el != null) {
//			el.focus();
//		}
	}
	///////////////////////////////////////////////////////////////////////////////////
	changeCameraMode() {
		if (this.cameraMode == "chaseCopter") {
			this.cameraMode = "orbital";
			
			//this.cameraEngineOrbital = new CameraEngineOrbital(this.scene, this.canvas);
			this.camera = this.cameraEngineOrbital.getCamera();
			
		} else {
			this.cameraMode = "chaseCopter";

			//const position = this.vehiclePhys.chassisBody.position;
			//const quaternion = this.vehiclePhys.chassisBody.quaternion;
			//this.cameraEngineChaseCopter = new CameraEngineChaseCopter(this.scene, position, quaternion);
			
			this.camera = this.cameraEngineChaseCopter.getCamera();
		}
	}
	///////////////////////////////////////////////////////////////////////////////////
	changeCarShowMode() {
		if (this.car != null) {
			this.car.changeShowMode();
		}
	}
	///////////////////////////////////////////////////////////////////////////////////
	changeTerrainShowMode() {
		// включаем/выключаем отображение физических квадратов поверхности и физических строк дорожной насыпи
		this.terrainPhysicsShow = !this.terrainPhysicsShow;
		
		if (this.terrainPhysicsShow) {
			this.scene.add(this.visibleObjectPhysSquares);
			this.scene.add(this.visibleObjectPhysStrings);
		} else {
			this.scene.remove(this.visibleObjectPhysSquares);
			this.scene.remove(this.visibleObjectPhysStrings);
		}
		
	}
	///////////////////////////////////////////////////////////////////////////////////
	createWater() {
		// вода
		const waterGeometry = new THREE.PlaneGeometry(1024, 1024);  // размер фиксированный, а координаты X, Z двигаем вместе с машиной
		this.water = new Water(waterGeometry, {
			textureWidth: 512,
			textureHeight: 512,
			waterNormals: new THREE.TextureLoader().load("/images/waternormals.jpg",  texture => {
			texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
			}),
			sunDirection: new THREE.Vector3(),
			sunColor: 0xffffff,
			waterColor: 0x0072ff,
			distortionScale: 4,
			fog: this.scene.fog !== undefined
		});
		this.water.rotation.x = -Math.PI / 2;
		this.water.position.y = -130;
		this.scene.add(this.water);

	}
	///////////////////////////////////////////////////////////////////////////////////
	createTrimesh(geometry: THREE.BufferGeometry): CANNON.Trimesh {
        const vertices = geometry.clone().toNonIndexed().attributes.position.array as unknown as number[]
        const indices = Object.keys(vertices).map(Number)
        return new CANNON.Trimesh(vertices, indices)
    }	
    ///////////////////////////////////////////////////////////////////////////////////
	///////////////////////////////////////////////////////////////////////////////////
	addLights(scene: THREE.Scene) {

		const ambientLight = new THREE.AmbientLight(0xffffff, 0.4);
		scene.add(ambientLight);

		this.directionalLight = new THREE.DirectionalLight(0xffffff, 0.75);
//		this.directionalLight.position.set(1, 0.2, 0);
///		this.directionalLight.position.set(1, 0.2, 0);
		this.directionalLight.position.set(1000, 250, 0);
		this.directionalLight.target.position.set(0, 0, 0);

		this.directionalLight.castShadow = true;		
//		this.directionalLight.shadow.bias = -0.0001;
		this.directionalLight.shadow.mapSize.width = 1024;
		this.directionalLight.shadow.mapSize.height = 1024;
		
//		this.directionalLight.shadow.camera.near = 0.5
		//this.directionalLight.shadow.camera.far = 100
		
		this.directionalLight.shadow.camera.top = 2000;
		this.directionalLight.shadow.camera.bottom = - 2000;
		this.directionalLight.shadow.camera.left = - 2000;
		this.directionalLight.shadow.camera.right = 2000;
		this.directionalLight.shadow.camera.near = 1;
		this.directionalLight.shadow.camera.far = 2000;		
		
		scene.add(this.directionalLight);
		
		
		///scene.add( new THREE.CameraHelper( directionalLight.shadow.camera ) );
		
	}
	///////////////////////////////////////////////////////////////////////////////////
	addControls() {
		// управление клавиатурой
		// Keybindings
		// Add force on keydown
		document.addEventListener('keydown', (event: any) => {
			
//			console.log('keydown, event = ' + JSON.stringify(event));
			
        setTimeout(() => {
			
			console.log('keydown, event.key = ' + event.key);
			
			
			switch (event.key) {
				case ' ':
					this.car.control("s+");
					break;
				case 'w':
				case 'ArrowUp':
					this.car.control("u+");
					break;

				case 's':
				case 'ArrowDown':
					this.car.control("d+");
					break;

				case 'a':
				case 'ArrowLeft':
					this.car.control("l+");
					break;

				case 'd':
				case 'ArrowRight':
					this.car.control("r+");
					break;
			}
        }, 200)
			
			
			
			
			
        })

        // Reset force on keyup
		document.addEventListener('keyup', (event: any) => {
			
			console.log('keyup, event = ' + JSON.stringify(event));

        setTimeout(() => {

			console.log('keyup, event.key = ' + event.key);
			
			switch (event.key) {
				case ' ':
					this.car.control("s-");
					break;
				case 'w':
				case 'ArrowUp':
					this.car.control("u-");
					break;

				case 's':
				case 'ArrowDown':
					this.car.control("d-");
					break;

				case 'a':
				case 'ArrowLeft':
					this.car.control("l-");
					break;

				case 'd':
				case 'ArrowRight':
					this.car.control("r-");
					break;
			}
        }, 200)
		})
		
	}
	///////////////////////////////////////////////////////////////////////////////////
	animate() {
		// определяем клеточные координаты автомобиля игрока (пока только игрока, без соперника)
		// - таких координат 2 набора - графический и физический
		
		const carX = this.car.getPhysBodyPosition().x;
		const carZ = this.car.getPhysBodyPosition().z;
		
		// координаты 0, 0 - в центре квадрата 0, 0   
		const cellPhysX = Math.round(carX / this.TERRAIN_PHYS_SQUARE_SIZE);  
		const cellPhysZ = Math.round(carZ / this.TERRAIN_PHYS_SQUARE_SIZE);
		
		let st = document.getElementById("cellPhysX");
		if (st != null) {
			st.innerHTML = "" + cellPhysX;
		}
		st = document.getElementById("cellPhysZ");
		if (st != null) {
			st.innerHTML = "" + cellPhysZ;
		}

		const carXRounded = cellPhysX * this.TERRAIN_PHYS_SQUARE_SIZE; 
		let x1;
		let x2;
		if (carX == carXRounded) {
			x1 = cellPhysX;
			x2 = x1;
		} else if (carX < carXRounded) {
			x1 = cellPhysX - 1;
			x2 = cellPhysX;
		} else {
			x1 = cellPhysX;
			x2 = cellPhysX + 1;
		}
		
		const carZRounded = cellPhysZ * this.TERRAIN_PHYS_SQUARE_SIZE; 
		let z1;
		let z2;
		if (carZ == carZRounded) {
			z1 = cellPhysZ;
			z2 = z1;
		} else if (carZ < carZRounded) {
			z1 = cellPhysZ - 1;
			z2 = cellPhysZ;
		} else {
			z1 = cellPhysZ;
			z2 = cellPhysZ + 1;
		}
		
		// создаём список актуальных физических квадратов
		const newPhysSquaresList: string[] = [];
		
		const newPhysStringsList: string[] = [];  // пусть тоже string, для единообразия
		
		// создаём от 1 до 4 физических квадратов поверхности
		// - если уже созданы, то не создаём
		// - неактуальные квадраты удаляем
		for (let z = z1; z <= z2; z++) {
			
			const stringKey = "" + z;
			
			newPhysStringsList.push(stringKey);
			
			const str = this.physStrings.get(stringKey);
			if (str === undefined) {
				// создаём физическую строку насыпи
				console.log("создаём физическую строку насыпи с key = " + stringKey + "; carX = " + carX + ", carZ = " + carZ);
				
					const body: CANNON.Body = this.createRoadBankPhysString(z);
					
					this.physStrings.set(stringKey, body);
					
					// визуализация (для отладки)
					const physVysObject = new THREE.Object3D();
					this.visibleObjectPhysStrings.add(physVysObject);
					
					this.physStringsVisual.set(stringKey, physVysObject);
					
					this.physVisUtil.addVisual(physVysObject, body, "trimesh", "physTerrain", 0.1);
				
			}
			
			for (let x = x1; x <= x2; x++) {
				
				const key = "" + x + ":" + z; 
				
				newPhysSquaresList.push(key);
				
				const square = this.physSquares.get(key);
				console.log("square = " + square);
				
				if (square === undefined) {
					// создаём физический квадрат
					console.log("создаём физический квадрат с key = " + key + "; carX = " + carX + ", carZ = " + carZ);
				
					const body = this.createTerrainPhysSquare(x, z);
					
					this.physSquares.set(key, body);
					
					// визуализация физического квадрата (для отладки)
					const physVysObject = new THREE.Object3D();
					this.visibleObjectPhysSquares.add(physVysObject);
					
					this.physSquaresVisual.set(key, physVysObject);
					
					this.physVisUtil.addVisual(physVysObject, body, "trimesh", "physTerrain", 0.1);

					
				}
				
			}
		}
		
		//console.log("удаляем старые, более неактуальные физические квадраты");
		
		// удаляем старые, более неактуальные физические квадраты
		for (let i = 0; i < this.physSquaresList.length; i++) {  // скан по предыдущему списку квадратов
			const key = this.physSquaresList[i];
			if (newPhysSquaresList.indexOf(key) == -1) {  // в новом списке такого квадрата нет 
				// - удаляем его body из world
				console.log("удаляем физический квадрат с key = " + key + "; carX = " + carX + ", carZ = " + carZ);

				const body = this.physSquares.get(key);
				
				console.log("body = " + body);
				
				if (body !== undefined) {   
					this.world.removeBody(body);
					
					this.physSquares.delete(key);
					
				}
				
				// также удаляем визуализацию удалённого квадрата
				const physVysObject = this.physSquaresVisual.get(key);
				if (physVysObject != undefined) {
					this.visibleObjectPhysSquares.remove(physVysObject);
					this.removeObjWithChildren(physVysObject);
					physVysObject.removeFromParent();
				}
				
				
			}
			
			
		}

		// заменяем старый список новым		
		this.physSquaresList = newPhysSquaresList;

		// то же самое делаем для физических строк дорожной насыпи
		for (let i = 0; i < this.physStringsList.length; i++) {  // скан по предыдущему списку строк
			const key = this.physStringsList[i];
			if (newPhysStringsList.indexOf(key) == -1) {  // в новом списке такого квадрата нет 
				// - удаляем его body из world
				console.log("удаляем физическую строку с key = " + key + "; carX = " + carX + ", carZ = " + carZ);

				const body = this.physStrings.get(key);
				
				console.log("body = " + body);
				
				if (body !== undefined) {   
					this.world.removeBody(body);
					
					this.physStrings.delete(key);
					
				}
				
				// также удаляем визуализацию удалённой строки
				const physVysObject = this.physStringsVisual.get(key);
				if (physVysObject != undefined) {
					this.visibleObjectPhysStrings.remove(physVysObject);
					this.removeObjWithChildren(physVysObject);
					physVysObject.removeFromParent();
				}
				
			}
			
			
		}
		




		this.physStringsList = newPhysStringsList;

		st = document.getElementById("physSquares");
		if (st != null) {
			st.innerHTML = "" + newPhysSquaresList.toString();
		}
		

		st = document.getElementById("numPhysSquares");
		if (st != null) {
			st.innerHTML = "" + this.physSquaresList.length;
		}
		
		
//		this.world.step(1/60);
///		for (let i = 0; i < 10; i++) {
		for (let i = 0; i < 1; i++) {
//		for (let i = 0; i < 2; i++) {
//			this.world.step(1/600);
			//this.world.step(1/200);
//			this.world.step(1/100);
//		}
//		this.world.step(1/240);

///		this.world.step(1/60);
		this.world.step(1/30);
		
		
			this.car.animate();

		}

		
//		const numVertices = this.TERRAIN_GRAPH_SQUARE_SIZE / this.TERRAIN_GRAPH_RESOLUTION_0;
		
		
		// графика поверхности
		const carCellGraphZ = Math.round(carZ / this.TERRAIN_GRAPH_SQUARE_SIZE);  // в какой клеточной строке находится машина
		//const carCellGraphZ = Math.round(carZ / this.TERRAIN_GRAPH_RESOLUTION_0); // - теперь клетки считаем не граф. квадратами, а по граф. разрешению 
		
		// актуализация списка графических квадратов, моделинг новых, удаление ненужных старых
		const newGraphSquaresList: string[] = [];
		
		// строки графических квадратов
		for (let layerZ = -this.TERRAIN_NUM_GRAPH_LAYERS; layerZ <= this.TERRAIN_NUM_GRAPH_LAYERS; layerZ++) {
			
//			const cellGraphZ = carCellGraphZ + layerZ * numVertices; 
			const cellGraphZ = carCellGraphZ + layerZ; 
			
			// находим клеточную координату дороги (упрощённо, только по cellGraphZ) 
			///const px = (cellGraphZ * this.TERRAIN_GRAPH_RESOLUTION_0 / 4 + 128) * 2 / 256;  // потом переименовать правильно (поменять везде с pz)

			// изгибы дороги - сдвигами влево-вправо (возвраты и самопересечения невозможны) 
			///const roadX = this.ROAD_AMPLITUDE_X * this.noise2D(px / 4, 0);  // метры
// ^- это можно потом закэшировать, т.к. лишние повторные расчёты			
			
			// столбцы графических квадратов
			for (let layerX = -this.TERRAIN_NUM_GRAPH_LAYERS; layerX <= this.TERRAIN_NUM_GRAPH_LAYERS; layerX++) {
				// клеточную координату X определяем относительно координаты дороги
				// - пока нет
				const cellGraphX = Math.round(carX / this.TERRAIN_GRAPH_SQUARE_SIZE) + layerX;  
//				const cellGraphX = Math.round(carX / this.TERRAIN_GRAPH_RESOLUTION_0) + layerX * numVertices; // - теперь клетки считаем не граф. квадратами, а по граф. разрешению 
//				const cellGraphX = Math.round(carX / this.TERRAIN_GRAPH_RESOLUTION_0) + layerX; // - теперь клетки считаем не граф. квадратами, а по граф. разрешению 
				
				const key = "" + cellGraphX + ":" + cellGraphZ; 
				newGraphSquaresList.push(key);
				const square = this.graphSquares.get(key);
				if (square == undefined) {
					// создаём графический квадрат
//					console.log("создаём графический квадрат с key = " + key + "; carX = " + carX + ", carZ = " + carZ);
					console.log("создаём графический квадрат с key = " + key);
					const object: THREE.Object3D = this.createTerrainGraphSquare(/*roadX, */cellGraphX, cellGraphZ);
					this.sceneRootObject.add(object);
					this.graphSquares.set(key, object);
				}
			
			}		
		
		}
		
		
		// удаляем старые, более неактуальные графические квадраты
		for (let i = 0; i < this.graphSquaresList.length; i++) {
			const key = this.graphSquaresList[i];
			if (newGraphSquaresList.indexOf(key) == -1) {
				// в новом списке такого квадрата нет, удаляем его объект из 3D-сцены
				console.log("удаляем графический квадрат с key = " + key + "; carX = " + carX + ", carZ = " + carZ);

				const object = this.graphSquares.get(key);
				if (object != undefined) {
					
					this.sceneRootObject.remove(object);
					this.removeObjWithChildren(object);
					object.removeFromParent();
					
					this.graphSquares.delete(key);
					
				}
				
			}
			
			
		}

		// заменяем старый список новым		
		this.graphSquaresList = newGraphSquaresList;
		
		st = document.getElementById("numGraphSquares");
		if (st != null) {
			st.innerHTML = "" + this.graphSquaresList.length;
		}
		
		
		
		///
		
		st = document.getElementById("numPolygons");
		if (st != null) {
			st.innerHTML = "" + this.renderer.info.render.triangles;
		}
		
		
		st = document.getElementById("numSceneElements");
		if (st != null) {
			st.innerHTML = "" + this.scene.children.length;
		}
		
		st = document.getElementById("numMapElements");
		if (st != null) {
			st.innerHTML = "" + this.sceneRootObject.children.length; 
		}
		
		st = document.getElementById("numPhysWorldElements");
		if (st != null) {
			st.innerHTML = "" + this.world.bodies.length; 
		}
		
		this.physVisUtil.updateVisuals();
		
		this.car.updateVisuals();
		
		
		if (this.cameraMode == "chaseCopter") {
			// прицепляю камеру к автомобилю
			if (this.cameraEngineChaseCopter != null) {
			
				const position = this.car.getPhysBodyPosition();
				
				console.log("car.position = " + position);
				
				const quaternion = this.car.getPhysBodyQuaternion();
			
				this.cameraEngineChaseCopter.animate(position, quaternion);
			
				console.log("velocity = " + this.car.getPhysBodyVelocity());  // вектор
			
			}
			
		} else {
			
			this.cameraEngineOrbital.animate();
			
		}
		
		// воду двигаем вместе с машиной
		this.water.position.x = this.car.getPhysBodyPosition().x;
		this.water.position.z = this.car.getPhysBodyPosition().z;

		// потом надо аналогично двигать солнышко
		
		


		this.stats.update();		

		this.renderer.render(this.scene, this.camera);

	}
	///////////////////////////////////////////////////////////////////////////////////
	removeObjWithChildren(obj: any) {
		if (obj.children.length > 0) {
			for (let x = obj.children.length - 1; x >= 0; x--) {
				this.removeObjWithChildren(obj.children[x])
			}
		}
		if (obj.isMesh) {
			obj.geometry.dispose();
			obj.material.dispose();
		}
		if (obj.parent) {
			obj.parent.remove(obj)

		}
	}	
	///////////////////////////////////////////////////////////////////////////////////
	createTerrainPhysSquare(cellX: number, cellZ: number) {
		// генерируем физический квадрат со стороной this.TERRAIN_PHYS_SQUARE_SIZE и центром cellX, cellZ (координаты клеточные; 0, 0 - в середине клетки) 
		
		console.log("createTerrainPhysSquare, cellX = " + cellX + ", cellZ = " + cellZ);
		
		// первый проход - расчёт высот в узлах карты; считаем на 1 узел дальше по каждой оси, поэтому <=, а не < 
		
		// строю 2 карты высот - для земли и для гор

		const physVertices = [];
		
		const sizeX = 256;
		const sizeZ = 256;
		
		const TERRAIN_PHYS_SQUARE_SIZE_HALF = this.TERRAIN_PHYS_SQUARE_SIZE / 2;  // 20/2 = 10
		
		for (let iC = -TERRAIN_PHYS_SQUARE_SIZE_HALF; iC <= TERRAIN_PHYS_SQUARE_SIZE_HALF; iC += this.TERRAIN_PHYS_RESOLUTION) {
			
			const i = cellZ * this.TERRAIN_PHYS_SQUARE_SIZE + iC;  // метры карты; 0 - в центре
			
			const pz = (i / 4 + 128) * 2 / sizeZ;

			// изгибы дороги - сдвигами влево-вправо (возвраты и самопересечения невозможны) 
			const roadLeft = this.ROAD_AMPLITUDE_X * this.noise2D(pz / 4, 0) - this.ROAD_HALF_WIDTH;
//			const roadRight = roadLeft + this.ROAD_HALF_WIDTH * 2;
			
			const roadLeftMountains = roadLeft - this.ROAD_HALF_WIDTH_MOUNTAINS;
			const roadRightMountains = roadLeft + this.ROAD_HALF_WIDTH_MOUNTAINS * 2;

			const roadLeftGround = roadLeft - this.ROAD_HALF_WIDTH_GROUND;
			const roadRightGround = roadLeft + this.ROAD_HALF_WIDTH_GROUND * 2;


			// модуляция высоты местности вдоль оси дороги 
			const heightM = this.ROAD_AMPLITUDE_Y * this.noise2D(pz / 4, 0);
			
			for (let jC = -TERRAIN_PHYS_SQUARE_SIZE_HALF; jC <= TERRAIN_PHYS_SQUARE_SIZE_HALF; jC += this.TERRAIN_PHYS_RESOLUTION) {

				const j = cellX * this.TERRAIN_PHYS_SQUARE_SIZE + jC;
				
				const px = (j / 4 + 128) * 2 / sizeX;
				
				// горы
				const noise1 = this.noise2D(pz / 4, px / 4);
				const noise2 = this.noise2D(px / 2, pz / 2);
				
				let height = this.MAX_HEIGHT_MOUNTAINS * this.noise2D(noise1 + pz * 2, Math.abs(noise2) + px) - 20;
				
				// дополнительная модуляция
				const height1 = 100 * this.noise2D(pz, px);
				const height2 = 20 * this.noise2D(pz * 16, px * 16);
				const height3 = 10 * this.noise2D(pz * 32, px * 32);
				
				height += height1 + height2 + height3;
				
				if (height < 0) {  // подземные горы пусть немножко остаются, для прорывов камня в низинах
					height *= 0.25;
				}

				if ((j >= roadLeftMountains) && (j < roadRightMountains)) {
					// область гор под дорогой уводим вниз, чтобы точно не вылезли; на нескоростных трассах потом надо наоборот, оставить выступчики, пусть объезжают
					height = -0.5;
				} else {
					// сглаживание прилегающих к дороге поверхностей (самое простое, линейное)
					let leftSlopeX = roadLeftMountains - this.ROAD_SLOPE_WIDTH_MOUNTAINS;
					let rightSlopeX = roadLeftMountains;

					if ((j >= leftSlopeX) && (j < rightSlopeX)) {
						const multiplier = (rightSlopeX - j) / this.ROAD_SLOPE_WIDTH_MOUNTAINS; 
						height *= multiplier;
					} else {
						leftSlopeX = roadRightMountains;  
						rightSlopeX = roadRightMountains + this.ROAD_SLOPE_WIDTH_MOUNTAINS;
						
						if ((j >= leftSlopeX) && (j < rightSlopeX)) {
							const multiplier = (j - leftSlopeX) / this.ROAD_SLOPE_WIDTH_MOUNTAINS; 
							height *= multiplier;
						}
					}
					
				}

				height += heightM;

				if (height <= -140) {  // делаем обрывы почётче; поверхность воды = -145
					height = -150;
				}
				
				const heightMountains = height;
				
				// земля
				height = this.MAX_HEIGHT_GROUND * this.noise2D(pz * 3, px * 3);

				if ((j >= roadLeftGround) && (j < roadRightGround)) {
					// дорога будет всегда ровной
					height = 0;
				} else {
					// сглаживание прилегающих к дороге поверхностей (самое простое, линейное)
					let leftSlopeZ = roadLeftGround - this.ROAD_SLOPE_WIDTH_GROUND;
					let rightSlopeZ = roadLeftGround;
					if ((j >= leftSlopeZ) && (j < rightSlopeZ)) {
						const multiplier = (rightSlopeZ - j) / this.ROAD_SLOPE_WIDTH_GROUND; 
						height *= multiplier;
					} else {
						leftSlopeZ = roadRightGround;  
						rightSlopeZ = roadRightGround + this.ROAD_SLOPE_WIDTH_GROUND;
						if ((j >= leftSlopeZ) && (j < rightSlopeZ)) {
							const multiplier = (j - leftSlopeZ) / this.ROAD_SLOPE_WIDTH_GROUND; 
							height *= multiplier;
						}
					}
					
				}

				// модуляция высоты местности вдоль оси дороги 
				height += heightM;

				if (height <= -140) {  // делаем обрывы почётче; поверхность воды = -145
					height = -150;
				}
				
				// из max(mountains, ground) каждого узла строим физическую сетку
				//const vCur = new THREE.Vector3((j - centerZ) * this.elementSize, Math.max(heightMountains, height), (i - centerZ) * this.elementSize);
				const vCur = new THREE.Vector3(j, Math.max(heightMountains, height), i);
				
				//console.log("vCur = " + vCur.x + ", " + vCur.y + ", " + vCur.z);
				
				physVertices.push(vCur.x);
				physVertices.push(vCur.y);
				physVertices.push(vCur.z);
				
			}
			
			
			
		}
		
		// второй проход - на основе карты высот строим физическую сетку
		const physIndices = [];
		
		let i = 0;
	
		const physSquareVerticesCount = this.TERRAIN_PHYS_SQUARE_SIZE / this.TERRAIN_PHYS_RESOLUTION;   	
	
		for (let iC = -TERRAIN_PHYS_SQUARE_SIZE_HALF; iC < TERRAIN_PHYS_SQUARE_SIZE_HALF; iC += this.TERRAIN_PHYS_RESOLUTION) {
			
			let j = 0;
			
			for (let jC = -TERRAIN_PHYS_SQUARE_SIZE_HALF; jC < TERRAIN_PHYS_SQUARE_SIZE_HALF; jC += this.TERRAIN_PHYS_RESOLUTION) {
			
				// строим физическую сетку (индексы вершин)
				physIndices.push(i * (physSquareVerticesCount + 1) + j);
				physIndices.push(i * (physSquareVerticesCount + 1) + j + 1);
				physIndices.push((i + 1) * (physSquareVerticesCount + 1) + j + 1);
				
				physIndices.push(i * (physSquareVerticesCount + 1) + j);
				physIndices.push((i + 1) * (physSquareVerticesCount + 1) + j + 1);
				physIndices.push((i + 1) * (physSquareVerticesCount + 1) + j);
				
				j++;
				
			}
			
			i++;
		}

		const body: CANNON.Body = new CANNON.Body({ mass: 0, material: this.groundMaterial });

		if ((this.carMode == 0) || (this.carMode == 2)) {
			// физика на основе first car shooter / rigidvehicle, работает с trimesh
			
			console.log("physVertices.length = " + physVertices.length);
			console.log("physIndices.length = " + physIndices.length);
			const shape: CANNON.Trimesh = new CANNON.Trimesh(physVertices, physIndices);
			console.log("shape.vertices.length = " + shape.vertices.length);

			body.addShape(shape);
			this.world.addBody(body);
			
		} else {
			// физика на основе raycastvehicle, работает с heightmap
			
			// вместо trimesh, не работающего с raycastvehicle, строим heightmap
			const matrix: number[][] = []

			for (let i = 0; i <= physSquareVerticesCount; i++) {  // <=, т.к. иначе пропускает одну вершину
				matrix.push([])
				for (let j = 0; j <= physSquareVerticesCount; j++) {
					const height: number = physVertices[(i * (physSquareVerticesCount + 1) + j) * 3 + 1];
					matrix[i].push(height)
				}
			}

			const shape = new CANNON.Heightfield(matrix, {
				elementSize: this.TERRAIN_PHYS_SQUARE_SIZE / physSquareVerticesCount,
			})
			
			body.addShape(shape);
			body.position.set(cellX * this.TERRAIN_PHYS_SQUARE_SIZE - TERRAIN_PHYS_SQUARE_SIZE_HALF,
			0,
			cellZ * this.TERRAIN_PHYS_SQUARE_SIZE - TERRAIN_PHYS_SQUARE_SIZE_HALF
			);
			body.quaternion.setFromEuler(-Math.PI / 2, 0, -Math.PI / 2);
			this.world.addBody(body);
		}
		
		return body;
	}
	///////////////////////////////////////////////////////////////////////////////////
	createRoadBankPhysString(cellZ: number) {
		console.log("createRoadBankPhysString, cellZ = " + cellZ);
		
		// насыпь строим так же, в два прохода (из-за индексирования вершин)
		
		// первый проход - расчёт высот в узлах карты; считаем на 1 узел дальше по каждой оси, поэтому <=, а не < 
		
		const physVertices = [];
		
		const sizeX = 256;
		const sizeZ = 256;
		
		const TERRAIN_PHYS_SQUARE_SIZE_HALF = this.TERRAIN_PHYS_SQUARE_SIZE / 2;  // 20/2 = 10
		
		for (let iC = -TERRAIN_PHYS_SQUARE_SIZE_HALF; iC <= TERRAIN_PHYS_SQUARE_SIZE_HALF; iC += this.TERRAIN_PHYS_RESOLUTION) {
			
			const i = cellZ * this.TERRAIN_PHYS_SQUARE_SIZE + iC;  // метры карты; 0 - в центре
			
			const pz = (i / 4 + 128) * 2 / sizeZ;

			// изгибы дороги - сдвигами влево-вправо (возвраты и самопересечения невозможны) 
			const roadLeft = this.ROAD_AMPLITUDE_X * this.noise2D(pz / 4, 0) - this.ROAD_HALF_WIDTH;
			
			// модуляция высоты местности вдоль оси дороги 
			const heightM = this.ROAD_AMPLITUDE_Y * this.noise2D(pz / 4, 0);

			const height = heightM + this.ROAD_BANK_HEIGHT;
			
			// левый откос дорожной насыпи
			physVertices.push(roadLeft - this.ROAD_BANK_WIDTH);
			physVertices.push(heightM);
			physVertices.push(i);
			
			physVertices.push(roadLeft);
			physVertices.push(height);
			physVertices.push(i);
			
			
			
			// дорога
			physVertices.push(roadLeft);
			physVertices.push(height);
			physVertices.push(i);
			
			physVertices.push(roadLeft + 2 * this.ROAD_HALF_WIDTH);
			physVertices.push(height);
			physVertices.push(i);
			
			// правый откос дорожной насыпи
			physVertices.push(roadLeft + 2 * this.ROAD_HALF_WIDTH);
			physVertices.push(height);
			physVertices.push(i);
			
			physVertices.push(roadLeft + 2 * this.ROAD_HALF_WIDTH + this.ROAD_BANK_WIDTH);
			physVertices.push(heightM);
			physVertices.push(i);
			
		}
		
		// второй проход - на основе карты высот строим физическую сетку
		const physIndices = [];
		
		let i = 0;
	
//		const physStringVerticesCount = 2;  // это пока только дорога; откосы добавят ещё 2 + 2
		const physStringVerticesCount = 6;  // это пока только дорога; откосы добавят ещё 2 + 2
	
		for (let iC = -TERRAIN_PHYS_SQUARE_SIZE_HALF; iC < TERRAIN_PHYS_SQUARE_SIZE_HALF; iC += this.TERRAIN_PHYS_RESOLUTION) {
			
			for (let j = 0; j < physStringVerticesCount; j++) {
			
				// строим физическую сетку (индексы вершин)
				physIndices.push(i * physStringVerticesCount + j);
				physIndices.push(i * physStringVerticesCount + j + 1);
				physIndices.push((i + 1) * physStringVerticesCount + j + 1);
				
				physIndices.push(i * physStringVerticesCount + j);
				physIndices.push((i + 1) * physStringVerticesCount + j + 1);
				physIndices.push((i + 1) * physStringVerticesCount + j);
				
			}
			
			i++;
		}

		const body: CANNON.Body = new CANNON.Body({ mass: 0, material: this.groundMaterial });

		if ((this.carMode == 0) || (this.carMode == 2)) {
			// физика на основе first car shooter / rigidvehicle, работает с trimesh
			
			console.log("physVertices.length = " + physVertices.length);
			console.log("physIndices.length = " + physIndices.length);
			const shape: CANNON.Trimesh = new CANNON.Trimesh(physVertices, physIndices);
			console.log("shape.vertices.length = " + shape.vertices.length);

			body.addShape(shape);
			this.world.addBody(body);
			
		} /* else {
			// физика на основе raycastvehicle, работает с heightmap
			
			// вместо trimesh, не работающего с raycastvehicle, строим heightmap
			const matrix: number[][] = []

			for (let i = 0; i <= physStringVerticesCount; i++) {  // <=, т.к. иначе пропускает одну вершину
				matrix.push([])
				for (let j = 0; j <= physStringVerticesCount; j++) {
					const height: number = physVertices[(i * (physStringVerticesCount + 1) + j) * 3 + 1];
					matrix[i].push(height)
				}
			}

			const shape = new CANNON.Heightfield(matrix, {
				elementSize: this.TERRAIN_PHYS_SQUARE_SIZE / physStringVerticesCount,
			})
			
			body.addShape(shape);
			body.position.set(cellX * this.TERRAIN_PHYS_SQUARE_SIZE - TERRAIN_PHYS_SQUARE_SIZE_HALF,
			0,
			cellZ * this.TERRAIN_PHYS_SQUARE_SIZE - TERRAIN_PHYS_SQUARE_SIZE_HALF
			);
			body.quaternion.setFromEuler(-Math.PI / 2, 0, -Math.PI / 2);
			this.world.addBody(body);
		}
		*/
		
		return body;
		
		
		
		
	}
	///////////////////////////////////////////////////////////////////////////////////
	createTerrainGraphSquare(/*roadX: number, */cellX: number, cellZ: number) {  // здесь roadX - смещение квадрата от дороги
		// генерируем графический квадрат со стороной this.TERRAIN_GRAPH_SQUARE_SIZE и центром cellX, cellZ (координаты клеточные; 0, 0 - в середине клетки)
		
		// разрешение графики зависит только от расстояния до дороги, по оси X
		
		let resolutionStep;
		switch (Math.abs(cellX)) {
			case 0:
				resolutionStep = this.TERRAIN_GRAPH_RESOLUTION_0;
				break;
			case 1:
				resolutionStep = this.TERRAIN_GRAPH_RESOLUTION_1;
				break;
			default:
				resolutionStep = this.TERRAIN_GRAPH_RESOLUTION_2;
		}
		
		const object = new THREE.Object3D();
		
		// размер квадрата на самом деле другой, а это просто коэффициенты 
		const sizeX = 256;
		const sizeZ = sizeX;

		// первый проход - расчёт высот в узлах карты; считаем на 1 узел дальше по каждой оси, поэтому <=, а не < 
		
		// строю 2 карты высот - для земли и для гор
		// - и сразу, на этом же проходе строю дорогу

		const pointsRoad: THREE.Vector3[] = [];
		const uvsRoad = [];
		
		//const pointsRoadBank: THREE.Vector3[] = [];
		//const uvsRoadBank = [];
		
		
		
		const heightmap: any[] = [];  // двумерный массив объектов со свойствами ground, heightMountains; возможно, добавится ещё что-то, потому и объекты

		let i = 0;
		
		const numVertices = this.TERRAIN_GRAPH_SQUARE_SIZE / resolutionStep;  // для текстур
		
		console.log("numVertices = " + numVertices);
		
		
		const TERRAIN_GRAPH_SQUARE_SIZE_HALF = this.TERRAIN_GRAPH_SQUARE_SIZE / 2;
		
		for (let iC = -TERRAIN_GRAPH_SQUARE_SIZE_HALF; iC <= TERRAIN_GRAPH_SQUARE_SIZE_HALF; iC += resolutionStep) {
			
			const z = cellZ * this.TERRAIN_GRAPH_SQUARE_SIZE + iC;  // метры
			
			const px = (z / 4 + 128) * 2 / sizeZ;

			// изгибы дороги - сдвигами влево-вправо (возвраты и самопересечения невозможны) 
			const roadLeft = this.ROAD_AMPLITUDE_X * this.noise2D(px / 4, 0) - this.ROAD_HALF_WIDTH;
			const roadRight = roadLeft + this.ROAD_HALF_WIDTH * 2;
			
			const roadLeftMountains = roadLeft - this.ROAD_HALF_WIDTH_MOUNTAINS;
			const roadRightMountains = roadLeft + this.ROAD_HALF_WIDTH_MOUNTAINS * 2;

			const roadLeftGround = roadLeft - this.ROAD_HALF_WIDTH_GROUND;
			const roadRightGround = roadLeft + this.ROAD_HALF_WIDTH_GROUND * 2;
			
			// модуляция высоты местности вдоль оси дороги 
			const heightM = this.ROAD_AMPLITUDE_Y * this.noise2D(px / 4, 0);
			

			heightmap.push([]);

			let j = 0;

			for (let jC = -TERRAIN_GRAPH_SQUARE_SIZE_HALF; jC <= TERRAIN_GRAPH_SQUARE_SIZE_HALF; jC += resolutionStep) {

				const x = cellX * this.TERRAIN_GRAPH_SQUARE_SIZE + jC;  // метры
				
				const pz = (x / 4 + 128) * 2 / sizeX;
				
				// горы
				const noise1 = this.noise2D(px / 4, pz / 4);
				const noise2 = this.noise2D(pz / 2, px / 2);
				
				let height = this.MAX_HEIGHT_MOUNTAINS * this.noise2D(noise1 + px * 2, Math.abs(noise2) + pz) - 20;
				
				// дополнительная модуляция для получения более реалистичных гор
				const height1 = 100 * this.noise2D(px, pz);
				const height2 = 20 * this.noise2D(px * 16, pz * 16);
				const height3 = 10 * this.noise2D(px * 32, pz * 32);
				
				height += height1 + height2 + height3;
				
				if (height < 0) {  // подземные горы пусть немножко остаются, для прорывов камня в низинах
					height *= 0.25;
				}

				if ((x >= roadLeftMountains) && (x < roadRightMountains)) {
					// область гор под дорогой уводим вниз; на нескоростных трассах потом можно наоборот, оставить выступчики, пусть объезжают
					height = -0.5;
				} else {
					// сглаживание прилегающих к дороге поверхностей (самое простое, линейное)
					let slopeLeft = roadLeftMountains - this.ROAD_SLOPE_WIDTH_MOUNTAINS;
					let slopeRight = roadLeftMountains;

					if ((x >= slopeLeft) && (x < slopeRight)) {
						const multiplier = (slopeRight - x) / this.ROAD_SLOPE_WIDTH_MOUNTAINS; 
						height *= multiplier;
					} else {
						slopeLeft = roadRightMountains;  
						slopeRight = roadRightMountains + this.ROAD_SLOPE_WIDTH_MOUNTAINS;
						
						if ((x >= slopeLeft) && (x < slopeRight)) {
							const multiplier = (x - slopeLeft) / this.ROAD_SLOPE_WIDTH_MOUNTAINS; 
							height *= multiplier;
						}
					}
					
				}

				height += heightM;

				if (height <= -140) {  // делаем обрывы почётче; поверхность воды = -145
					height = -150;
				}
				
				const heightMountains = height;
				
				// земля
				height = this.MAX_HEIGHT_GROUND * this.noise2D(px * 3, pz * 3);

				if ((x >= roadLeftGround) && (x < roadRightGround)) {
					// дорога будет всегда ровной
					height = 0;
				} else {
					// сглаживание прилегающих к дороге поверхностей (самое простое, линейное)
					let leftSlopeX = roadLeftGround - this.ROAD_SLOPE_WIDTH_GROUND;
					let rightSlopeZ = roadLeftGround;
					if ((x >= leftSlopeX) && (x < rightSlopeZ)) {
						const multiplier = (rightSlopeZ - x) / this.ROAD_SLOPE_WIDTH_GROUND; 
						height *= multiplier;
					} else {
						leftSlopeX = roadRightGround;  
						rightSlopeZ = roadRightGround + this.ROAD_SLOPE_WIDTH_GROUND;
						if ((x >= leftSlopeX) && (x < rightSlopeZ)) {
							const multiplier = (x - leftSlopeX) / this.ROAD_SLOPE_WIDTH_GROUND; 
							height *= multiplier;
						}
					}
					
				}

				// модуляция высоты местности вдоль оси дороги 
				height += heightM;

				if (height <= -140) {  // делаем обрывы почётче; поверхность воды = -145
					height = -150;
				}
				
				const nodeObj = { mountains: heightMountains, ground: height};
				
				heightmap[i].push(nodeObj);

				j++;

			}
			
			
			// дорогу считаем сразу, на первом проходе
			if (iC < TERRAIN_GRAPH_SQUARE_SIZE_HALF) {  // последний элемент лишний, для дороги не нужен
//			if (iC == -TERRAIN_GRAPH_SQUARE_SIZE_HALF) {  // для отладки создаём только один элемент
				
				const pxFar = ((z + resolutionStep) / 4 + 128) * 2 / sizeZ;
			
				const roadLeftFar = this.ROAD_AMPLITUDE_X * this.noise2D(pxFar / 4, 0) - this.ROAD_HALF_WIDTH;
				const roadRightFar = roadLeftFar + this.ROAD_HALF_WIDTH * 2;
			
				const heightMFar = this.ROAD_AMPLITUDE_Y * this.noise2D(pxFar / 4, 0);
			
				const shiftRoadBank = 0.02;  // приподнимаем над местностью основание насыпи
				const shiftRoad = shiftRoadBank + this.ROAD_BANK_HEIGHT;  // приподнимаем дорогу на высоту насыпи

				const fullWidth = 2 * (this.ROAD_HALF_WIDTH + this.ROAD_BANK_WIDTH); 

				const u0 = 0;
				const u1 = this.ROAD_BANK_WIDTH / fullWidth;
				const u2 = (fullWidth - this.ROAD_BANK_WIDTH) / fullWidth;
				const u3 = 1;

//				const u0 = 0;
//				const u1 = 0.1;
//				const u2 = 0.9;
//				const u3 = 1;


//				const mult = 2; // тайлинг (только вдоль дороги, поперёк не надо)
//				const v0 = (i / numVertices * mult) % 1;
//				const v1 = ((i + 1) / numVertices * mult) % 1;
				const v0 = 0;
				const v1 = 1;


//				const roadTextureAspectRatio = 3.174285714285714; // = 1111 / 350
//				const textureDivider = fullWidth * roadTextureAspectRatio;   
//				const v0 = ((z / textureDivider) + 1000000000) % 1;
//				const v1 = (((z + resolutionStep) + 1000000000) / textureDivider) % 1;


//const textureDivider = this.TERRAIN_GRAPH_SQUARE_SIZE;
//				const v0 = i * resolutionStep / textureDivider;
//				const v1 = (i * resolutionStep + resolutionStep) / textureDivider;
			
				// создаём два левых треугольника насыпи, добавляем в геометрию
				let vLeftClose = new THREE.Vector3(roadLeft - this.ROAD_BANK_WIDTH, heightM + shiftRoadBank, z);
				let vLeftFar = new THREE.Vector3(roadLeftFar - this.ROAD_BANK_WIDTH, heightMFar + shiftRoadBank, z + resolutionStep);
			
				let vRightClose = new THREE.Vector3(roadLeft, heightM + shiftRoad, z);
				let vRightFar = new THREE.Vector3(roadLeftFar, heightMFar + shiftRoad, z + resolutionStep);

				pointsRoad.push(vLeftClose);
				pointsRoad.push(vLeftFar);
				pointsRoad.push(vRightFar);
			
				pointsRoad.push(vRightFar);
				pointsRoad.push(vRightClose);
				pointsRoad.push(vLeftClose);
/*
				uvsRoad.push(u0, v0, 
							u1, v0, 
							u1, v1);
			
				uvsRoad.push(u1, v1, 
							u0, v1, 
							u0, v0);
*/
				uvsRoad.push(u0, v0, 
							u0, v1, 
							u1, v1);
			
				uvsRoad.push(u1, v1, 
							u1, v0, 
							u0, v0);
			
			
				// создаём два треугольника дороги, добавляем в геометрию

				vLeftClose = new THREE.Vector3(roadLeft, heightM + shiftRoad, z);
				vLeftFar = new THREE.Vector3(roadLeftFar, heightMFar + shiftRoad, z + resolutionStep);
			
				vRightClose = new THREE.Vector3(roadRight, heightM + shiftRoad, z);
				vRightFar = new THREE.Vector3(roadRightFar, heightMFar + shiftRoad, z + resolutionStep);
			
				pointsRoad.push(vLeftClose);
				pointsRoad.push(vLeftFar);
				pointsRoad.push(vRightFar);
			
				pointsRoad.push(vRightFar);
				pointsRoad.push(vRightClose);
				pointsRoad.push(vLeftClose);

				uvsRoad.push(u1, v0, 
							u2, v0, 
							u2, v1);
			
				uvsRoad.push(u2, v1, 
							u1, v1, 
							u1, v0);

			
				// создаём два правых треугольника насыпи, добавляем в геометрию
				vLeftClose = new THREE.Vector3(roadRight, heightM + shiftRoad, z);
				vLeftFar = new THREE.Vector3(roadRightFar, heightMFar + shiftRoad, z + resolutionStep);
			
				vRightClose = new THREE.Vector3(roadRight + this.ROAD_BANK_WIDTH, heightM + shiftRoadBank, z);
				vRightFar = new THREE.Vector3(roadRightFar + this.ROAD_BANK_WIDTH, heightMFar + shiftRoadBank, z + resolutionStep);
			
				pointsRoad.push(vLeftClose);
				pointsRoad.push(vLeftFar);
				pointsRoad.push(vRightFar);
			
				pointsRoad.push(vRightFar);
				pointsRoad.push(vRightClose);
				pointsRoad.push(vLeftClose);

//				u0 = 0;
//				u1 = 1;

				uvsRoad.push(u2, v0, 
							u2, v1, 
							u3, v1);
			
				uvsRoad.push(u3, v1, 
							u3, v0, 
							u2, v0);

/*
				uvsRoad.push(u2, v0, 
							u3, v0, 
							u3, v1);
			
				uvsRoad.push(u3, v1, 
							u2, v1, 
							u2, v0);
*/			
			
				
			}
			
			
			i++;
		}
		
		
		
		const pointsGround: THREE.Vector3[] = [];
		const uvsGround = [];
		
		const pointsMountains: THREE.Vector3[] = [];
		const uvsMountains = [];
		
		i = 0;
		
		// второй проход - на основе карты высот строим сетки
		for (let iC = -TERRAIN_GRAPH_SQUARE_SIZE_HALF; iC < TERRAIN_GRAPH_SQUARE_SIZE_HALF; iC += resolutionStep) {
			
			const z = cellZ * this.TERRAIN_GRAPH_SQUARE_SIZE + iC;  // метры
			
			let j = 0;
			
			
			for (let jC = -TERRAIN_GRAPH_SQUARE_SIZE_HALF; jC < TERRAIN_GRAPH_SQUARE_SIZE_HALF; jC += resolutionStep) {
			
				const x = cellX * this.TERRAIN_GRAPH_SQUARE_SIZE + jC /*- 0*roadX*/;  // метры
			
				// создаём меш ground
				let vLeftClose = new THREE.Vector3(x, heightmap[i][j].ground, z);
				let vLeftFar = new THREE.Vector3(x, heightmap[i + 1][j].ground, z + resolutionStep);
			
				let vRightClose = new THREE.Vector3(x + resolutionStep, heightmap[i][j + 1].ground + 0 * (i % 2), z);
				let vRightFar = new THREE.Vector3(x + resolutionStep, heightmap[i + 1][j + 1].ground + 0 * (i % 2), z + resolutionStep);
				
				pointsGround.push(vLeftClose);
				pointsGround.push(vLeftFar);
				pointsGround.push(vRightFar);
				
				pointsGround.push(vRightFar);
				pointsGround.push(vRightClose);
				pointsGround.push(vLeftClose);
				
//				let textureMult = 1 / 1024;
				
				let u0 = j / numVertices;
				let u1 = (j + 1)  / numVertices;
				let v0 = i / numVertices;
				let v1 = (i + 1) / numVertices;
	
				uvsGround.push(u0, v0, 
							u0, v1, 
							u1, v1);
			
				uvsGround.push(u1, v1, 
							u1, v0, 
							u0, v0);

				// создаём меш mountains
				vLeftClose = new THREE.Vector3(x, heightmap[i][j].mountains, z);
				vLeftFar = new THREE.Vector3(x, heightmap[i + 1][j].mountains, z + resolutionStep);
			
				vRightClose = new THREE.Vector3(x + resolutionStep, heightmap[i][j + 1].mountains, z);
				vRightFar = new THREE.Vector3(x + resolutionStep, heightmap[i + 1][j + 1].mountains, z + resolutionStep);
				
				pointsMountains.push(vLeftClose);
				pointsMountains.push(vLeftFar);
				pointsMountains.push(vRightFar);
				
				pointsMountains.push(vRightFar);
				pointsMountains.push(vRightClose);
				pointsMountains.push(vLeftClose);
				
//				textureMult = 4;  // тайлинг
//				textureMult = 1; // 128;  // тайлинг

				u0 = j / numVertices;
				u1 = (j + 1)  / numVertices;
				v0 = i / numVertices;
				v1 = (i + 1) / numVertices;
				
				uvsMountains.push(u0, v0, 
							u0, v1, 
							u1, v1);
			
				uvsMountains.push(u1, v1, 
							u1, v0, 
							u0, v0);
							
				j++;			
				
			}
			
			i++;
		}

		// ground
		let geometry: THREE.BufferGeometry = new THREE.BufferGeometry();   
		geometry.setFromPoints(pointsGround);
		geometry.computeBoundingSphere();
		geometry.computeVertexNormals();
		
		const nUvComponents = 2;
		geometry.setAttribute('uv', new THREE.BufferAttribute(new Float32Array(uvsGround), nUvComponents));

		const meshGround: THREE.Mesh = new THREE.Mesh(geometry, this.materialGround);
		meshGround.receiveShadow = true;
		meshGround.castShadow = true;
		object.add(meshGround);

		// mountains
		geometry = new THREE.BufferGeometry();   
		geometry.setFromPoints(pointsMountains);
		geometry.computeBoundingSphere();
		geometry.computeVertexNormals();
		
		geometry.setAttribute('uv', new THREE.BufferAttribute(new Float32Array(uvsMountains), nUvComponents));


		const meshMountains: THREE.Mesh = new THREE.Mesh(geometry, this.materialMountains);
		meshMountains.castShadow = true;
		object.add(meshMountains);

		/*
		// насыпь
		geometry = new THREE.BufferGeometry();   
		geometry.setFromPoints(pointsRoadBank);
		geometry.computeBoundingSphere();
		geometry.computeVertexNormals();
		
		geometry.setAttribute('uv', new THREE.BufferAttribute(new Float32Array(uvsRoadBank), nUvComponents));

//		const meshRoadBank: THREE.Mesh = new THREE.Mesh(geometry, this.materialGround);
		const meshRoadBank: THREE.Mesh = new THREE.Mesh(geometry, this.materialRoad);
		meshRoadBank.receiveShadow = true;
		object.add(meshRoadBank);
		*/


		// дорога
		geometry = new THREE.BufferGeometry();   
		geometry.setFromPoints(pointsRoad);
		geometry.computeBoundingSphere();
		geometry.computeVertexNormals();
		
		geometry.setAttribute('uv', new THREE.BufferAttribute(new Float32Array(uvsRoad), nUvComponents));

		const meshRoad: THREE.Mesh = new THREE.Mesh(geometry, this.materialRoad);
//		const wireframeMaterial = new THREE.MeshBasicMaterial({ color: 0x00ff00, wireframe: true });
//		const meshRoad: THREE.Mesh = new THREE.Mesh(geometry, wireframeMaterial);
		meshRoad.receiveShadow = true;
		object.add(meshRoad);
		
		
		return object;
	}
	///////////////////////////////////////////////////////////////////////////////////
	getCamera() {
		return this.camera;
	}
	///////////////////////////////////////////////////////////////////////////////////
	switchAutoSteering(autoSteeringChecked: boolean) {
		if (this.car != null) {
			this.car.switchAutoSteering(autoSteeringChecked);
		}
	}
	///////////////////////////////////////////////////////////////////////////////////

}
export default GameSceneRace;
